<div class="multiple-tags">
  @if (firstTag) {
    <app-tag [tags]="firstTag"></app-tag>
  }
  @if (remainingCount > 0) {
    <div class="remaining-count" [matTooltip]="remainingTagsTooltip">+{{ remainingCount }}</div>
  }
</div>
